import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  corpRequestLoading: false,
  error: null,
  corporateRequests: {
    loading: false,
    error: null,
    data: [],
    totalPages: 0,
    totalRecords: 0,
    page: 0,
    pageSize: 0,
    sortOn: '',
    sortDir: '',
    filter: {status: 'Pending'},
  },
  updateCorpReqLoading: false,
  updateCorpSuccess: false,
};

export const helpDeskSlice = createSlice({
  name: 'helpdesk',
  initialState,
  reducers: {
    fetchCorporateRequestsRequest: (state) => {
      state.corporateRequests.loading = true;
      state.corporateRequests.error = null;
    },
    fetchCorporateRequestsSuccess: (state, {payload}) => {
      const {
        data,
        page,
        pageSize,
        totalPages,
        totalRecords,
        sortOn,
        sortDir,
        filter,
      } = payload;
      state.corporateRequests.loading = false;
      state.corporateRequests.data = data;
      state.corporateRequests.page = page;
      state.corporateRequests.pageSize = pageSize;
      state.corporateRequests.totalPages = totalPages;
      state.corporateRequests.totalCount = totalRecords;
      state.corporateRequests.sortOn = sortOn;
      state.corporateRequests.sortDir = sortDir;
      state.corporateRequests.filter = filter;
    },
    fetchCorporateRequestsError: (state, {payload}) => {
      state.corporateRequests.loading = false;
      state.corporateRequests.error = payload;
    },

    updateCorporateRequestRequest: (state) => {
      state.updateCorpReqLoading = true;
      state.error = null;
    },
    updateCorporateRequestSuccess: (state, {payload}) => {
      state.updateCorpReqLoading = false;
      const foundCorp = state.corporateRequests.data.findIndex(
        (item) => item.id === payload.id
      );
      if (foundCorp >= 0) {
        state.corporateRequests.data[foundCorp].status = payload.status;
        state.corporateRequests.data[foundCorp].ownerFeedback =
          payload.ownerFeedback;
      }
      state.updateCorpSuccess = true;
    },
    updateCorporateRequestError: (state, {payload}) => {
      state.updateCorpReqLoading = false;
      state.error = payload;
    },
    resetUpdateCorpSuccess: (state) => {
      state.updateCorpSuccess = false;
    },
  },
});

export const {
  fetchCorporateRequestsRequest,
  fetchCorporateRequestsSuccess,
  fetchCorporateRequestsError,
  updateCorporateRequestRequest,
  updateCorporateRequestSuccess,
  updateCorporateRequestError,
  resetUpdateCorpSuccess,
} = helpDeskSlice.actions;

export default helpDeskSlice.reducer;
